import { Component } from '@angular/core';
import { EngagementComponent } from './engagement.component';

@Component({
  selector: 'eid-engagement-desktop',
  templateUrl: './engagement.desktop.component.html',
  styleUrls: ['./engagement.desktop.component.scss']
})
export class EngagementDesktopComponent extends EngagementComponent {}
